(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-hockey/assets/javascripts/league.js') >= 0) return;  svs.modules.push('/components/themes/sport-hockey/assets/javascripts/league.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_hockey = svs.themes.sport_hockey || {};

  svs.themes.sport_hockey.formatTable = function(league) {
    _.each(league, function(team) {
      if (_.isObject(team)) {
        team.position = parseInt(team.position, 10);

        if (team.winOverTime && team.winPenalty) {
          team.winOverTimeOrPenalty =
            parseInt(team.winOverTime, 10) + parseInt(team.winPenalty, 10);
          team.wins -= team.winOverTimeOrPenalty;
        }
        if (team.lossOverTime && team.lossPenalty) {
          team.lossOverTimeOrPenalty =
            parseInt(team.lossOverTime, 10) + parseInt(team.lossPenalty, 10);
          team.losses -= team.lossOverTimeOrPenalty;
        }
      }
    });
    return league;
  };

  svs.themes.sport_hockey.getFormationByPosition = function() {
    return {};
  };

  svs.themes.sport_hockey.isShowHomeAwayTables = function() {
    return true;
  };
})(svs);

 })(window);